<template>
  <v-navigation-drawer
    v-model="isShowForm"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px;"
    stateless
  >
    <div class="d-flex flex-column" style="height: calc(100% - 64px);">
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              สถานะการส่งคำสั่ง
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ commandData.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <div class="px-5 pb-5" style="height: 100%; overflow: auto;">
        <HardwareConnectionFormEmployeeSyncListItem
          v-for="employee in commandData.employees"
          :key="employee.employee_uuid"
          :employee="employee"
          :hardware="hardware"
          :syncCode="commandData.syncCode"
          :identifyMode="commandData.identifyMode"
          @onClickResponse="handleClickResponse"
        />
      </div>
    </div>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import HardwareConnectionFormEmployeeSyncListItem from '@/views/hardware/HardwareConnectionFormEmployeeSyncListItem'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    HardwareConnectionFormEmployeeSyncListItem,
    ConfirmDialog
  },

  props: {
    isShowForm: {
      type: Boolean,
      required: true
    },
    hardware: {
      type: Object,
      required: true
    },
    commandData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {}
    }
  },

  methods: {
    handleClickBack() {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการละทิ้งการดำเนินการทั้งหมด?',
        text:
          'คุณยังไม่ได้ดำเนินการ คุณแน่ใจหรือไม่ว่าต้องการละทิ้งการดำเนินการทั้งหมด',
        value: ''
      }
      this.confirmDialogDataChange = true
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$emit('onClickBack')
    },
    handleClickResponse(responseData) {
      const payload = {
        title: this.commandData.title,
        ...responseData
      }
      this.$emit('onClickResponse', payload)
    }
  }
}
</script>
